"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _excluded = ["children"],
    _excluded2 = ["title", "body"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Container = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "error-message__Container",
  componentId: "sc-1uon86b-0"
})(["border:1px solid ", ";border-radius:4px;"], function (props) {
  return (0, _styles.colors)("error", props);
});
var propTypesErrorText = {
  children: _propTypes.node
};

var ErrorText = function ErrorText(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return children ? /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    color: "error",
    fontSize: 2
  }, props), children) : null;
};

ErrorText.propTypes = propTypesErrorText;
var propTypes = {
  /** Error title */
  body: _propTypes.string,

  /** Error message content */
  title: _propTypes.string
};
/**
 * Stylized error message component for displaying error information. Useful
 * for displaying form or network errors and prompting further action from the
 * user. Requires one or both of title and body props to be defined and of the
 * node type.
 */

var ErrorMessage = function ErrorMessage(_ref2) {
  var title = _ref2.title,
      body = _ref2.body,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  return /*#__PURE__*/_react["default"].createElement(Container, _extends({
    backgroundColor: "error-background",
    color: "error",
    p: 2
  }, props), /*#__PURE__*/_react["default"].createElement(ErrorText, {
    fontWeight: 2,
    mb: body ? 1 : 0
  }, title), /*#__PURE__*/_react["default"].createElement(ErrorText, null, body));
};

ErrorMessage.propTypes = propTypes;
var _default = ErrorMessage;
exports["default"] = _default;